import React from 'react';
import axios from 'axios';
import { Button, Form, Header, Segment, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class NewSP1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgUnit: this.props.orgUnit,
            studyProgramBasic: this.props.studyProgramBasic,
            studyPrograms: this.props.studyPrograms,
            studyProgramsDropdown: [],
            studyCyclesDropdown: [],
            studyCycleId: this.props.studyCycleId,
            languageIds: this.props.languageIds,
            organizationalUnitIds: this.props.organizationalUnitIds,
            academicYear: this.props.academicYearStart,
            name: this.props.name,
            nameEng: this.props.nameEng,
            ects: this.props.ects,
            durationYear: this.props.durationYear,
            durationSemester: this.props.durationSemester,
            allStudyPrograms: [],
            SPorgUnits: this.props.SPorgUnits,
            title: this.props.title,

            orgUnitErr: false,
            studyProgramBasicErr: false,
            studyCycleIdErr: false,
            languageIdsErr: false,
            organizationalUnitIdsErr: false,
            academicYearErr: false,
            nameErr: false,
            ectsErr: false,
            durationYearErr: false,
            durationSemesterErr: false,
            titleErr: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.step2 = this.step2.bind(this);
        this.resetValues = this.resetValues.bind(this);
        this.getSPorgUnits = this.getSPorgUnits.bind(this);
    }

    // componentDidMount() {
    //     if (this.state.orgUnit) {
    //         this.getStudyPrograms(this.props.orgUnit);
    //     }
    //     if (this.props.create) {
    //         if (!this.props.success) {
    //             toast('Došlo je do greške! Smjer (studijski program) nije kreiran!');
    //         }
    //     }
    // }


    componentDidMount() {
        axios.get('organizational-units/5/children')
    }

    getSPorgUnits(sProgram) {
        axios.get(`study-programs/organizational-units/${sProgram}`)
            .then(res => {
                const SPorgUnits = res.data.map(el => ({
                    key: el.organizationalUnitId, value: el.organizationalUnitId, text: el.organizationalUnitName
                }));
                this.setState({ SPorgUnits });
            })
            .catch(err => {
                console.log('Failed to fetch org units');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'orgUnit') {
            this.getStudyPrograms(value);
        }

        if (name === 'studyProgramBasic') {
            this.setState({
                studyCyclesDropdown: this.state.studyProgramsDropdown.filter(el => el.key === value).map(e => ({
                    key: e.studyProgramBasic.studyCycles[0].id, value: e.studyProgramBasic.studyCycles[0].id, text: e.studyProgramBasic.studyCycles[0].name
                }))
            });
            this.getSPorgUnits(value);
        }
    }

    step2() {
        if (!this.state.orgUnit || !this.state.studyProgramBasic || !this.state.studyCycleId ||
        (this.state.languageIds.length === 0) || (this.state.organizationalUnitIds.length === 0) ||
        !this.state.academicYear || !this.state.name || !this.state.ects
          || !this.state.durationYear || !this.state.durationSemester || !this.state.title) {
            toast('Niste unijeli sva obavezna polja!');

            if (!this.state.orgUnit) { this.setState({ orgUnitErr: true }); } else { this.setState({ orgUnitErr: false }); }
            if (!this.state.studyProgramBasic) { this.setState({ studyProgramBasicErr: true }); } else { this.setState({ studyProgramBasicErr: false }); }
            if (!this.state.studyCycleId) { this.setState({ studyCycleIdErr: true }); } else { this.setState({ studyCycleIdErr: false }); }
            if (this.state.languageIds.length === 0) { this.setState({ languageIdsErr: true }); } else { this.setState({ languageIdsErr: false }); }
            if (this.state.organizationalUnitIds.length === 0) { this.setState({ organizationalUnitIdsErr: true }); } else { this.setState({ organizationalUnitIdsErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!this.state.ects) { this.setState({ ectsErr: true }); } else { this.setState({ ectsErr: false }); }
            if (!this.state.durationYear) { this.setState({ durationYearErr: true }); } else { this.setState({ durationYearErr: false }); }
            if (!this.state.durationSemester) { this.setState({ durationSemesterErr: true }); } else { this.setState({ durationSemesterErr: false }); }
            if (!this.state.title) { this.setState({ titleErr: true }); } else { this.setState({ titleErr: false }); }
        } else {
            this.props.step2(
                this.state.orgUnit,
                this.state.studyProgramBasic,
                this.state.studyCycleId,
                this.state.languageIds,
                this.state.organizationalUnitIds,
                this.state.academicYear,
                this.state.name,
                this.state.nameEng,
                this.state.ects,
                this.state.durationYear,
                this.state.durationSemester,
                this.state.SPorgUnits,
                this.state.title
            );
        }
    }

    resetValues() {
        this.setState({
            orgUnit: '',
            studyProgramBasic: '',
            studyPrograms: '',
            studyProgramsDropdown: [],
            studyCycleId: '',
            languageIds: '',
            organizationalUnitIds: '',
            academicYear: '',
            name: '',
            nameEng: null,
            ects: '',
            durationYear: '',
            durationSemester: '',
            allStudyPrograms: [],
            title: '',

            orgUnitErr: false,
            studyProgramBasicErr: false,
            studyCycleIdErr: false,
            languageIdsErr: false,
            organizationalUnitIdsErr: false,
            academicYearErr: false,
            nameErr: false,
            ectsErr: false,
            durationYearErr: false,
            durationSemesterErr: false,
            titleErr: false
        });
        this.props.resetValues();
    }


    getStudyPrograms(orgUnit) {
        let obj = {};
        axios.post(`study-programs/basic/${orgUnit}`, { ...obj })
            .then(res => {
                const studyProgramsDropdown = res.data.map(el => ({
                    ...el, key: el.studyProgramBasic.id, value: el.studyProgramBasic.id, text: el.studyProgramBasic.comment != null ? el.studyProgramBasic.name + ' | ' + el.studyProgramBasic.comment + ' | ' + el.studyProgramBasic.studyCycles[0].name : el.studyProgramBasic.name + ' | ' + el.studyProgramBasic.studyCycles[0].name
                    // ...el, key: el.studyProgramBasic.id, value: el.studyProgramBasic.id, text: el.studyProgramBasic.name
                }));
                const allStudyPrograms = res.data;
                this.setState({
                    studyProgramsDropdown: studyProgramsDropdown.filter(el => el.archived !== true),
                    allStudyPrograms,
                });
            })
            .catch(err => {
                console.log('Failed to fetch StudyPrograms');
            });
    }

    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije smjera (studijskog programa)</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Forma za unos
                        </Header>
                    </Segment>
                    <Segment>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.orgUnitErr}>
                                    <label>Organizaciona jedinica osnovnog smjera (studijskog programa)</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.orgUnit}
                                        onChange={this.handleInputChange}
                                        name="orgUnit"
                                        options={this.props.orgUnits}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field disabled={!this.state.orgUnit} required error={this.state.studyProgramBasicErr}>
                                    <label>Osnovni smjer (studijski program)</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite smjer (studijski program)"
                                        value={this.state.studyProgramBasic}
                                        onChange={this.handleInputChange}
                                        name="studyProgramBasic"
                                        options={this.state.studyProgramsDropdown}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.studyCycleIdErr} disabled={!this.state.studyProgramBasic}>
                                    <label>Studijski ciklus</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite studijski ciklus"
                                        value={this.state.studyCycleId}
                                        onChange={this.handleInputChange}
                                        name="studyCycleId"
                                        options={this.state.studyCyclesDropdown}
                                        // options={this.props.studyCyclesDropdown}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.languageIdsErr}>
                                    <label>Jezici</label>
                                    <Form.Dropdown
                                        clearable
                                        multiple
                                        selection
                                        placeholder="Odaberite jedan ili više jezika"
                                        value={this.state.languageIds}
                                        onChange={this.handleInputChange}
                                        name="languageIds"
                                        options={this.props.languagesDropdown}
                                        search
                                        fluid
                                    />
                                </Form.Field>

                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.organizationalUnitIdsErr}>
                                    <label>Organizacione jedinice</label>
                                    <Form.Dropdown
                                        clearable
                                        multiple
                                        selection
                                        placeholder="Odaberite jednu ili više organizacionih jedinica"
                                        value={this.state.organizationalUnitIds}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitIds"
                                        options={this.state.SPorgUnits}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.academicYearErr}>
                                    <label>Akademska godina početka</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite od koje akademske godine važi smjer (studijski program)"
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.props.academicYearsDropdown}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Input}
                                    error={this.state.nameErr}
                                    value={this.state.name}
                                    label="Naziv implementacije smjera (studijskog programa)"
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                    name="name"
                                    placeholder="Bosanski / hrvatski / srpski"
                                />
                                <Form.Field
                                    control={Input}
                                    value={this.state.nameEng}
                                    label="Naziv implementacije smjera (studijskog programa)"
                                    onChange={(e) => this.setState({ nameEng: e.target.value })}
                                    name="nameEng"
                                    placeholder="Engleski jezik"
                                />
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    error={this.state.durationYearErr}
                                    control={Input}
                                    label="Trajanje (godine)"
                                    type="number"
                                    value={this.state.durationYear}
                                    onChange={(e) => this.setState({ durationYear: e.target.value, durationSemester: e.target.value * 2 })}
                                    name="durationYear"
                                    placeholder="Unesite broj godina"
                                />
                                <Form.Field
                                    required
                                    error={this.state.durationSemesterErr}
                                    control={Input}
                                    label="Trajanje (semestri)"
                                    type="number"
                                    value={this.state.durationSemester}
                                    onChange={(e) => this.setState({ durationSemester: e.target.value, durationYear: e.target.value / 2 })}
                                    name="durationSemester"
                                    placeholder="Unesite broj semestara"
                                />
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Input}
                                    error={this.state.ectsErr}
                                    label="Broj ECTS bodova"
                                    type="number"
                                    value={this.state.ects}
                                    onChange={(e) => this.setState({ ects: e.target.value })}
                                    name="ects"
                                    placeholder="Unesite broj ects bodova"
                                />
                                <Form.Field required error={this.state.titleErr}>
                                    <label>Titula</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite titulu"
                                        value={this.state.title}
                                        onChange={this.handleInputChange}
                                        name="title"
                                        options={this.props.titles}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>

                        </Form>
                    </Segment>
                    <Segment clearing>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.resetValues}
                        >Odustani</Button>
                        <Button primary floated="right" onClick={this.step2}>Dalje</Button>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default NewSP1;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewSP1.js